import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AppProviders } from './app/providers';
import { router } from './app/router';
import { logger } from './lib/logging';
import { initSentry } from './lib/telemetry/sentry';
import './i18n/config';
import './styles/index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container not found');
}

logger.info('Frontend bootstrap started', { event: 'frontend.app.started' });
initSentry();

createRoot(container).render(
  <StrictMode>
    <AppProviders router={router} />
  </StrictMode>,
);
